<div>
    <h2 id="page-heading">
        <span class="d-flex align-items-baseline gap-2">
            <span>Runner logs</span>
            <span class="logs-active col-mono" *ngIf="hasRunners()">{{ activeRunner }}</span>
        </span>

        <div class="logs-account-picker">
            <label class="logs-account-label" for="logsRunningAccount">Executing account</label>
            <select class="form-select form-select-sm logs-account-select" id="logsRunningAccount"
                    [(ngModel)]="selectedAccount" (ngModelChange)="onRunningAccountChange()">
                <option value="">All accounts</option>
                <option *ngFor="let entry of running; trackBy: trackByAccountCode" [value]="entry.accountCode">
                    {{ entry.accountCode }} &mdash; {{ entry.runnerCode }}
                </option>
            </select>
            <button type="button" class="btn btn-sm btn-outline-secondary"
                    [disabled]="!selectedAccount" (click)="openAccount()"
                    title="Open this account on the Accounts page">
                <i class="fa fa-external-link"></i>
                <span class="hidden-sm-down">Account</span>
            </button>
        </div>
    </h2>

    <div class="logs-alert" *ngIf="error && !hasRunners()">
        <i class="fa fa-exclamation-triangle"></i>
        <span>{{ error }}</span>
    </div>

    <div class="logs-empty empty-state" *ngIf="!hasRunners() && !error">
        <i class="fa fa-inbox"></i>
        <span>No runners registered yet.</span>
    </div>

    <div class="card" *ngIf="hasRunners()">
        <div class="logs-tabs">
            <button type="button" class="logs-tab" *ngFor="let runner of runners; trackBy: trackByRunnerCode"
                    [class.active]="runner.runnerCode === activeRunner"
                    [class.inactive]="isInactive(runner)"
                    [disabled]="isInactive(runner)"
                    [title]="runner.runnerCode + ' — ' + stateLabel(runner)"
                    (click)="selectRunner(runner)">
                <span class="logs-tab-dot" [style.background]="stateColor(runner)"></span>
                <span>{{ runner.runnerCode }}</span>
                <span class="logs-tab-state" *ngIf="isInactive(runner)">{{ stateLabel(runner) }}</span>
            </button>

            <div class="logs-tabs-actions">
                <div class="btn-group btn-group-sm logs-view" role="group">
                    <button type="button" class="btn"
                            [class.btn-primary]="!isObserver()" [class.btn-outline-secondary]="isObserver()"
                            (click)="selectView('logs')">
                        <i class="fa fa-list"></i><span>Logs</span>
                    </button>
                    <button type="button" class="btn"
                            [class.btn-primary]="isObserver()" [class.btn-outline-secondary]="!isObserver()"
                            (click)="selectView('observer')">
                        <i class="fa fa-desktop"></i><span>Observer</span>
                    </button>
                </div>

                <select class="form-select form-select-sm logs-select" *ngIf="!isObserver()"
                        [(ngModel)]="selectedStream" (ngModelChange)="onFilterChange()"
                        title="Log stream">
                    <option value="">All streams</option>
                    <option value="runner">Runner</option>
                    <option value="deploy">Deploy</option>
                    <option value="orchestrator">Orchestrator</option>
                    <option value="screencast">Screencast</option>
                </select>

                <div class="form-check logs-follow" *ngIf="!isObserver()">
                    <input class="form-check-input" type="checkbox" id="logsFollow" [(ngModel)]="follow">
                    <label class="form-check-label" for="logsFollow">follow</label>
                </div>
            </div>
        </div>

        <div class="logs-body">
            <div class="logs-note logs-note-top" *ngIf="activeRunnerState()">
                Runner {{ activeRunner }} is {{ activeRunnerState() }} — no new lines will arrive.
            </div>

            <app-observer [hidden]="!isObserver()"
                          [active]="isObserver()"
                          [runner]="activeRunner"
                          [account]="selectedAccount"></app-observer>

            <div [hidden]="isObserver()">
                <div class="logs-alert" *ngIf="error">
                    <i class="fa fa-exclamation-triangle"></i>
                    <span>{{ error }}</span>
                </div>

                <text-viewer [text]="text"
                             [(follow)]="follow"
                             [startLine]="droppedLines + 1"
                             [filename]="activeRunner + '.log'"></text-viewer>

                <div class="logs-note" *ngIf="droppedLines > 0">
                    This tab keeps the last {{ maxBufferLines }} lines. Earlier lines were dropped from the browser.
                </div>
            </div>
        </div>
    </div>
</div>
